import { DisplayElementModel } from '../../PageBuilder/models/display-element.model';
import { ReportSeriesModel } from './report-series.model';
import { ChartDisplayElementModel } from './chart-display-element.model';
import { ChartStylesModel } from '../../Charts/models/chart-styles.model';

export class CoverageSummaryChartDisplayElementModel extends ChartDisplayElementModel implements DisplayElementModel {
    set series(series: ReportSeriesModel[]) {
        this._series = series;

        if (!this._series || !this._series.length) {
            return;
        }

        if (!this.styles) {
            this.styles = new ChartStylesModel();
        }
    }

    get series(): ReportSeriesModel[] {
        return this._series;
    }

    constructor(
        title: string,
        series: ReportSeriesModel[],
        styles?: any
    ) {
        super(title, series, styles);
    }
}
